<template>
  <SDataTable :headers="headers" :items="sensors">
    <template v-slot:item.macAddress="{ item }">
      <div class="font-weight-bold">{{ item.macAddress }}</div>
    </template>

    <template v-slot:item.createdAt="{ item }">
      {{ item.createdAt | dateFilter }}
    </template>

    <template v-slot:item.place="{ item }">
      {{ item.place == "" ? "-" : item.place }}
    </template>

    <template v-slot:item.connectionType="{ item }">
      <div class="d-flex justify-start align-center font-weight-bold">
        <v-img
          :src="item.connectionType == 'BLE' ? ble : lora"
          max-width="50"
        ></v-img>
        <div class="ml-1">-</div>
        <div class="ml-1">
          {{ item.connectionType == "BLE" ? "BLE" : "LoRa" }}
        </div>
      </div>
    </template>

    <template v-slot:item.provider="{ item }">
      <div class="d-flex justify-center">
        <v-img
          v-if="item.provider == 'ORANGE'"
          :src="orangeProvider"
          max-width="35"
        >
        </v-img>
        <v-img
          v-else-if="item.provider == 'OBJENIOUS'"
          :src="objeniousProvider"
          max-width="70"
        >
        </v-img>
        <v-img v-else :src="clientProvider" max-width="50"></v-img>
      </div>
    </template>
  </SDataTable>
</template>

<script>
import { mapGetters } from "vuex";
import ble from "@/assets/icons/ble.gif";
import lora from "@/assets/icons/lorawan.gif";
import orangeProvider from "@/assets/icons/orange.png";
import objeniousProvider from "@/assets/icons/objenious.png";
import clientProvider from "@/assets/icons/client.gif";
import dateFilter from "@filters/dateFilter";

export default {
  name: "UserSensorsTable",
  data: () => ({
    ble,
    lora,
    orangeProvider,
    objeniousProvider,
    clientProvider,
    headers: [
      { text: "Adresse Mac", value: "macAddress", align: "center" },
      { text: "Nom capteur", value: "nickname", align: "center" },
      { text: "Endroit", value: "place", align: "center" },
      { text: "Mode", value: "connectionType", align: "center" },
      { text: "Fournisseur", value: "provider", align: "center" },
      { text: "Date d'ajout", value: "createdAt", align: "center" },
    ],
    sensors: [],
  }),
  methods: {
    editOne(sensor) {
      return this.$emit("askUpdate", sensor);
    },
    viewOne(sensor) {
      return this.$router.push({
        name: "SensorCharts",
        params: { sensorId: sensor.macAddress },
      });
    },
  },
  computed: {
    ...mapGetters({
      getUserSensors: "sensors/getUserSensors",
      user: "users/getUser",
    }),
  },
  watch: {
    getUserSensors: {
      deep: true,
      handler() {
        this.sensors = this.getUserSensors;
      },
    },
  },
  filters: {
    dateFilter,
  },
  created() {},
};
</script>

<style></style>
